import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDialog, {
    style: {
      zIndex: _vm.options.zIndex
    },
    attrs: {
      persistent: "",
      "max-width": "100%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.cancel.apply(null, arguments);
      }
    },
    model: {
      value: _vm.shown,
      callback: function callback($$v) {
        _vm.shown = $$v;
      },
      expression: "shown"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Stock choice")])]), _vm.wine ? _c(VCardText, [_c("div", {
    staticClass: "wine-naming"
  }, [_c("wine-naming", {
    key: "wine-naming-".concat(_vm.wine.id_wine),
    attrs: {
      wineNamingData: _vm.wine.naming_data,
      isPrefixWinery: true,
      isSuffixBottling: true,
      isSuffixType: true
    }
  })], 1), !_vm.isUsedStockSwitchable && _vm.isChangingUsedStock ? _c("div", {
    staticClass: "mt-6"
  }, [_c("div", {
    staticClass: "errorLabel"
  }, [_c("div", {
    staticClass: "text-bigger"
  }, [_vm._v("This product is already in your cart.")]), _c("ul", {
    staticClass: "mt-3"
  }, [_c("li", [_vm._v(" To choose the used stock, you have to remove it from the cart and add it again, or access to the cart finalization page. ")]), _c("li", [_vm._v(" To change quantity, you can click on the cart items number in the header menu, or access to the cart finalization page. ")])])])]) : _c("div", {
    staticClass: "wine-stock-table"
  }, [_c(VDataTable, {
    staticClass: "elevation-2",
    attrs: {
      id: "table",
      headers: _vm.headers,
      items: _vm.isLoading ? [] : _vm.items,
      loading: _vm.isLoading,
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.firstAction",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c("StockActionButton", {
          attrs: {
            item: item,
            isChangingUsedStock: _vm.isChangingUsedStock,
            wineStockStatus: _vm.wineStockStatus,
            isBasket: _vm.isBasket,
            isLoading: _vm.isLoading,
            isAddToCartDisabled: _vm.isAddToCartDisabled(item)
          },
          on: {
            cancel: _vm.cancel,
            addProduct: function addProduct($event) {
              return _vm.addProduct(item);
            }
          }
        })];
      }
    }, {
      key: "item.type",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [!_vm.isUsedStockSwitchable ? _c("svg", {
          staticClass: "icon icon-xxs dot",
          class: ["fill-".concat(item.statusLabel)],
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            width: "512",
            height: "512",
            viewBox: "0 0 512 512"
          }
        }, [_c("circle", {
          attrs: {
            cx: "256",
            cy: "256",
            r: "256"
          }
        })]) : _vm._e(), _vm._v(" " + _vm._s(item.type) + " ")];
      }
    }, {
      key: "item.stock_quantity",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", [_vm._v(_vm._s(item.stock_quantity) + " b.")]), item.preArrivalQuantity > 0 ? _c("div", {
          staticClass: "text-smaller text-orange text-nowrap"
        }, [_vm._v(" PreArrival: " + _vm._s(item.preArrivalQuantity) + " b. ")]) : _vm._e()];
      }
    }, {
      key: "item.case",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c(VTextField, {
          staticClass: "v-text-field-no-label --pb-small",
          attrs: {
            "hide-details": "auto",
            placeholder: "0",
            type: "number",
            min: "0",
            max: _vm.isAddToCartDisabled(item) || _vm.isChangingUsedStock && item.status === _vm.wineStockStatus.DEFAULT ? null : item.max_quantity_case,
            disabled: _vm.isAddToCartDisabled(item) || _vm.isChangingUsedStock && item.status === _vm.wineStockStatus.DEFAULT || _vm.quantityIsFixed
          },
          model: {
            value: item.case,
            callback: function callback($$v) {
              _vm.$set(item, "case", $$v);
            },
            expression: "item.case"
          }
        })];
      }
    }, {
      key: "item.casingId",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c(VSelect, {
          staticClass: "v-text-field-no-label",
          attrs: {
            items: _vm.casingsAvailable,
            "item-value": "casingId",
            "item-text": "textCard",
            "hide-details": "auto",
            disabled: _vm.isAddToCartDisabled(item) || _vm.isChangingUsedStock && item.status === _vm.wineStockStatus.DEFAULT || _vm.quantityIsFixed
          },
          on: {
            change: function change($event) {
              return _vm.updateInitialQuantity(item);
            }
          },
          model: {
            value: item.casingId,
            callback: function callback($$v) {
              _vm.$set(item, "casingId", $$v);
            },
            expression: "item.casingId"
          }
        })];
      }
    }, {
      key: "item.warning",
      fn: function fn(_ref6) {
        var item = _ref6.item;
        return [item.canBeBypassStockReservation ? _c("div", [_c(VMenu, {
          attrs: {
            "open-on-hover": "",
            top: "",
            "offset-y": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref7) {
              var on = _ref7.on,
                attrs = _ref7.attrs;
              return [_c(VIcon, _vm._g(_vm._b({
                attrs: {
                  color: "orange darken-2"
                }
              }, "v-icon", attrs, false), on), [_vm._v("mdi-alert")])];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "pa-2 text-sm"
        }, [_c("ul", {
          staticClass: "stock-reservation-warning-list"
        }, _vm._l(item.warningReasons, function (message) {
          return _c("li", {
            key: message
          }, [_vm._v(" " + _vm._s(message) + " ")]);
        }), 0)])], 1)], 1) : _vm._e()];
      }
    }, {
      key: "item.action",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c("StockActionButton", {
          attrs: {
            item: item,
            isChangingUsedStock: _vm.isChangingUsedStock,
            wineStockStatus: _vm.wineStockStatus,
            isBasket: _vm.isBasket,
            isLoading: _vm.isLoading,
            isAddToCartDisabled: _vm.isAddToCartDisabled(item)
          },
          on: {
            cancel: _vm.cancel,
            addProduct: function addProduct($event) {
              return _vm.addProduct(item);
            }
          }
        })];
      }
    }], null, true)
  })], 1)]) : _vm._e(), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.cancel();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };